import { Button } from '@mui/material';
import { Download } from '@mui/icons-material';
// @ts-ignore
import Excel from './procurement_plan_template.xlsx'
import { useTranslation } from 'react-i18next';
import axiosInstance from 'store/axiosInstance';
import { downloadBlobData } from 'utils/file';
import { toast } from 'react-toastify';

interface Props {
  id: string
}

export function DownloadPlanTemplate({ id }: Props) {
  const { t } = useTranslation()

  const handleButtonClick = () => {
    axiosInstance.get(`/procurement-plans/${id}/items/download-template`, { responseType: 'blob' }).then(data => {
      downloadBlobData(data as unknown as string, 'procurement_plan_template.xlsx')
    }).catch(() => {
      toast.error(t('operation-failed'))
    })
  }

  return (
    <Button onClick={handleButtonClick} variant="text" startIcon={<Download />}>
      {t('download-template')}
    </Button>
  )
}
